import Grid from "@material-ui/core/Grid"
import { withStyles } from "@material-ui/core/styles"
import moment from "moment"
import React, { Component } from "react"

import OrganizationBreadcrumps from "../../components/OrganizationBreadcrumps"
import TitleBar from "../../components/TitleBar"
import TitleBarTitle from "../../components/TitleBarTitle"
import dispatcher from "../../dispatcher"
import history from "../../history"
import HandyRustyStore from "../../stores/HandyRustyStore"
import { errorHandler } from "../../stores/helpers"
import SessionStore from "../../stores/SessionStore"
import theme from "../../theme"
import FilterWirelessLogger from "./FilterWirelessLogger"
import ListWirelessLoggerTable from "./ListWirelessLoggerTable"
import SimpleDialog from "./SimpleDialog"
import fields from "./WirelessLoggerFieldset"

const FileDownload = require("downloadjs")

const styles = {
  chart: {
    width: 380,
  },
  tabs: {
    borderBottom: "1px solid " + theme.palette.divider,
    height: "48px",
    overflow: "visible",
  },
}

const defaultChecked = [
  "direction",
  "payload",
  "dateTime",
  "localTime",
  "devAddr",
  "devEUI",
  "fPort",
  "fCnt",
  "nFCnt",
  "rxRssi",
  "rxSnr",
  "esp",
  "SF",
  "channel",
  "gw",
  "GW Lat",
  "GW Long",
  "GW GWCnt",
  "mic",
]

class Diagnostics extends Component {
  constructor() {
    super()
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.checkSearchQuery = this.checkSearchQuery.bind(this)
    this.handleClickOpen = this.handleClickOpen.bind(this)
    this.handleClickClose = this.handleClickClose.bind(this)
    this.updateTable = this.updateTable.bind(this)
    this.resetTable = this.resetTable.bind(this)
    this.exportCSV = this.exportCSV.bind(this)
    this.changePageEvent = this.changePageEvent.bind(this)
    this.disableAutoUpdate = this.disableAutoUpdate.bind(this)
    this.setLastMonthLabel = this.setLastMonthLabel.bind(this)

    this.TableRef = React.createRef()
    this.FilterRef = React.createRef()
    this.ListRef = React.createRef()

    this.onCSVData = this.onCSVData.bind(this)
    this.onCSVSocketClose = this.onCSVSocketClose.bind(this)

    let storageLoggerFields = localStorage.getItem("LoggerFields")
    let parsed = storageLoggerFields ? JSON.parse(storageLoggerFields) : null

    let checked = defaultChecked
    if (parsed && parsed.length > 0) {
      checked = parsed
    }

    this.state = {
      csvData: "",
      exportTotal: 0,
      exportPerc: 0,
      tab: 0,
      fields: fields.filter((field) => checked.indexOf(field.dataName) > -1),
      checkedFields: checked,
      openFieldsDialog: false,
      filterChangeTimeOut: undefined,
      page: SessionStore.getPage(),
      filter: {
        "start": moment().subtract(1,'month').toISOString(),
        offset: 0,
        limit: SessionStore.getRowsPerPage(),
        filters: {
          direction: "",
          devEUI: "",
          devAddr: "",
          gw: "",
          mType: "",
        },
      },
    }

    this.timeout = null

    if (SessionStore.user !== null) {
      // canLoad = true
      if (!SessionStore.isAdmin()) {
        let orgId = SessionStore.getOrganizationID() || SessionStore.organizations[0].organizationID
        if (!SessionStore.isAdmin()) {
          this.state.filter.organizationId = orgId || undefined
        }
        this.state.filter.organizationId = orgId
      }
    }
  }

  changePageEvent() {
    this.disableAutoUpdate()
  }

  handleFilterChange(data, timeout = 1500, devEUIChanged, value) {
    let filter = this.state.filter

    let state = { filter: { ...filter, ...data } }

    let Obj = {}
    for (let i in state.filter) {
      if (i === "offset" || i === "limit" || i === "getTotal") {
        continue
      }

      if (i === "filters") {
        for (let f in state.filter[i]) {
          if (state.filter[i][f] !== null && state.filter[i][f] !== "" && state.filter[i][f] !== undefined) {
            Obj[f] = state.filter[i][f]
          }
        }
      } else {
        if (state.filter[i] !== "" && state.filter[i] !== null && state.filter[i] !== undefined) {
          Obj[i] = state.filter[i]
        }
      }
    }

    const u = new URLSearchParams(Obj).toString()

    this.props.history.replace("?" + u)
    this.ListRef.current.resetTotal()

    this.setState(state, () => {
      if (!devEUIChanged) {
        this.resetTable()
      }
      if (devEUIChanged && !value) {
        this.resetTable()
      }
    })
  }

  componentDidMount() {
     this.setLastMonthLabel() // ?

    if (SessionStore.user === null) {
      if (!SessionStore.fetchingProfile && SessionStore.getToken() === null) {
        SessionStore.fetchProfile(() => {})
      }

      SessionStore.on("userGot", () => {
        const userStore = SessionStore.getUser()

        if (userStore === null || userStore === undefined) {
          // canLoad = false
          window.sessionStorage.setItem("prevPage", "/diagnostics")
          history.replace("/login")
        } else {
          // canLoad = true
          let filter = this.state.filter
          if (filter.organizationId === undefined) {
            let orgId = SessionStore.getOrganizationID() ? SessionStore.getOrganizationID() : SessionStore.organizations.length > 0 ? SessionStore.organizations[0].organizationID : undefined
            if (!SessionStore.isAdmin()) {
              filter.organizationId = orgId
            }
          }

          this.setState(filter, () => {
            this.resetTable()
          })
        }
      })
    } else {
      if (SessionStore.getToken() !== null) {
        // canLoad = true
        this.forceUpdate()
      } else {
        // canLoad = false
        window.sessionStorage.setItem("prevPage", "/diagnostics")
        history.replace("/login")
      }
    }
  }

  checkSearchQuery(mode) {
    let search = window.location.hash.split("?")[1]
    let allowed = ["gw", "devEUI"]
    if (search) {
      let filter = {}
      search.split("&").forEach((el) => {
        let obj = el.split("=")
        if (allowed.indexOf(obj[0]) > -1) {
          filter[obj[0]] = obj[1]
        }
      })
      if (Object.keys(filter).length > 0) {
        if (mode && mode === "filter") {
          this.FilterRef.current.setState({
            filter: {
              filters: filter,
            },
          })
        } else {
          let state = this.state
          state.filter["filters"] = filter
          this.setState(state)
        }
      }
      if (this.props && this.props.history) {
        this.props.history.replace(this.props.history.location.pathname)
      }
    }
  }

  handleClickOpen() {
    this.setState({
      openFieldsDialog: true,
    })
  }

  handleClickClose(checkedFields) {
    let checked = checkedFields.length > 0 ? checkedFields : defaultChecked

    localStorage.setItem("LoggerFields", JSON.stringify(checked))
    this.setState({
      openFieldsDialog: false,
      checkedFields: checked,
      fields: fields.filter((field) => checked.includes(field.dataName)),
      limit: "limit",
    })
  }

  updateTable() {
    if (this.TableRef.current.updateTable) {
      this.TableRef.current.updateTable()
    }
  }

  resetTable() {
    if (this.TableRef.current.resetTable) {
      this.ListRef.current.firstLoad = true
      this.ListRef.current.resetTotal()
      this.TableRef.current.resetTable()
    }
  }

  notify(msg, type = "success") {
    dispatcher.dispatch({
      type: "CREATE_NOTIFICATION",
      notification: {
        type: type,
        message: msg,
      },
    })
  }

  exportCSV(filter, size, cb) {
    if (size === "all") {
      size = this.TableRef.current.getCount()
    }

    let fil = Object.assign({}, filter)
    fil.start = fil?.start ? moment(fil.start).toISOString() : ""
    fil.end = fil?.end ? moment(fil.end).toISOString() : ""

    fil["getTotal"] = false

    if (!fil.organizationId) {
      if (!SessionStore.isAdmin()) {
        fil.organizationId = SessionStore.getOrganizationID() || SessionStore.organizations[0].organizationID
      }
    }

    HandyRustyStore.getDeviceFramesCSV(fil, size, 0, this.onCSVData, this.onCSVSocketClose, cb)
  }

  onCSVData(d) {
    let currentPercentage = 0

    if (d.total != null) {
      this.total = d.total
      this.current = undefined
      this.setState({
        exportTotal: d.total,
      })
    }

    if (d.current) {
      this.current = d.current
    }

    if (d.chunk != null) {
      let data = this.state.csvData
      data = data + atob(d.chunk)

      if (this.state.exportTotal !== 0) {
        currentPercentage = Math.round((d.current * 100) / this.state.exportTotal)
      }

      this.setState({
        csvData: data,
        exportPerc: currentPercentage + "%",
      })
    }
  }

  onCSVSocketClose(cb) {
    let time = moment().format("DDMMYYYY_HHmm")
    if (this.state.csvData === "") {
      this.notify("Error: No data available!", "error")
      cb()

      return
    }
    if (this.total !== this.current) {
      errorHandler({ message: `Error: Data is not complete (got ${this.current} bytes out of ${this.total})` })
      cb()
      return
    }

    FileDownload(this.state.csvData, "Diagnostics_" + time + ".csv", "text/csv")
    this.notify("All the data downloaded!")

    this.setState({csvData: "", exportPerc: 0 }, () => {
      this.count = 0
      this.total = 0
      cb()      }
    )
  }

  disableAutoUpdate() {
    this.FilterRef.current.autoReloadOnChange({ target: { value: "" } })
  }

  setLastMonthLabel(props) {
    this.FilterRef.current.datePickerRef.current.setState({ date: "Last month", selectedOption: "Month" })
  }

  render() {
  
    return (
      <Grid container spacing={4} id={"diagnostics"}>
        <TitleBar>
          <OrganizationBreadcrumps globalFalse org={this.props.org}>
            <TitleBarTitle title="LoRaWAN Logger" />
          </OrganizationBreadcrumps>
        </TitleBar>
        <Grid item xs={12} style={{ paddingBottom: 0 }}>
          <FilterWirelessLogger
            ref={this.FilterRef}
            exportCSVPerc={this.state.exportPerc}
            clickOpenDialog={this.handleClickOpen}
            exportCSV={this.exportCSV}
            resetTable={this.resetTable}
            updateTable={this.updateTable}
            handleChange={this.handleFilterChange}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <ListWirelessLoggerTable
            ref={this.ListRef}
            fields={this.state.fields}
            limit={this.state.limit}
            filterRef={this.FilterRef}
            tableRef={this.TableRef}
            disableAutoUpdate={this.disableAutoUpdate}
            changePageEvent={this.changePageEvent}
            page={this.state.page}
            filter={this.state.filter}
          />
        </Grid>
        <SimpleDialog selectedFields={this.state.checkedFields} open={this.state.openFieldsDialog} onClose={this.handleClickClose} />
      </Grid>
    )
  }
}

export default withStyles(styles)(Diagnostics)
